import BargeVerified from "@/User/Assets/Svgs/BadgeVerified.svg";
import Key from "@/User/Assets/Svgs/Key.svg";
import Logo from "@/User/Assets/Svgs/Logo.svg";
import MessageNotify from "@/User/Assets/Svgs/MessageNotify.svg";
import SyncArrow from "@/User/Assets/Svgs/SyncArrow.svg";
import Typography from "@/User/Components/Typography";
import React from "react";

const FeatureItem = ({
    icon = '',
    alt = '',
    title = '',
    desciption = '',
    order = 'order-1',
    classImgName = '',
}) => (
    <div className={`${order} flex flex-col border-b border-silk-blue w-full md:max-w-343px`} >
        <div className="flex w-full">
            <img src={icon} alt={alt} className={classImgName} />
            <Typography
                variant="h3"
                color="primary"
                className="ml-4 text-wrap flex items-center lg:h-12.5 grow"
            >
                {title}
            </Typography>
        </div>
        <Typography variant="base" className="inline-flex items-center my-4 leading-6 grow">
            {desciption}
        </Typography>
    </div>
);

const Features = () => (
    <section
        id="features"
        className="container py-5 md:my-0 lg:py-10"
    >
        <div className="text-center text-primary mb-5">
            <div className="flex justify-center items-center mb-2.5">
                <img src={Logo} alt="リラパスの特徴" className="w-9 h-7" />
            </div>
            <Typography variant="h2" className="leading-tight">
                リラパスの特徴
            </Typography>
        </div>
        <div className="flex flex-col justify-center items-center">
            <div className="grid grid-cols-1 w-fit lg:grid-cols-2 gap-3">
                <FeatureItem
                    classImgName="w-10 h-10"
                    order="lg:order-1"
                    icon={MessageNotify}
                    alt="掲載企業からスカウトが届く"
                    title="掲載企業からスカウトが届く"
                    desciption="働きたいスタイル、希望条件を登録することで相性が良い企業から直接スカウトを受信。"
                />
                <FeatureItem
                    classImgName="w-10 h-10"
                    order="lg:order-3"
                    icon={SyncArrow}
                    alt="スムーズな企業とのやりとりが可能"
                    title="スムーズな企業とのやりとりが可能"
                    desciption="スカウト後、そのままメッセージ機能で企業側 とのやりとりが可能。説明会・面談へのステッ プがシームレスに。"
                />
                <FeatureItem
                    classImgName="w-10 h-10"
                    order="lg:order-2"
                    icon={Key}
                    alt="非公開ブランドあり"
                    title="非公開ブランドあり"
                    desciption="ブランドイメージを守る、応募を制限するため、世間的にフランチャイズ展開を公にしていないブランドなど、非公開案件のスカウトも。"
                />
                <FeatureItem
                    classImgName="w-10 h-10"
                    order="lg:order-4"
                    icon={BargeVerified}
                    alt="優良企業の案件のみを厳選"
                    title="優良企業の案件のみを厳選"
                    desciption="事業の撤廃率、継続率などに関する厳しい審査 に通った優良企業のみを掲載。"
                />
            </div>
        </div>
    </section>
);

export default Features;
